// English defaults for keys that do not yet exist in i18nexus. Passed to t() as
// `defaultValue` so English shows until the keys are added (EN + FR) there.
export const GENERAL_INVITE_DEFAULTS = {
  register_ready_to_shop_1: "You're registered and ready to shop!",
  register_ready_to_shop_2: "Use Start Shopping below to choose your products.",
  register_thank_you_2d:
    "We weren't able to email you a copy of your link right now, so tap Copy Link to save it in case you want to come back later.",
  sign_up_email_error_title: "We couldn't complete your registration",
  sign_up_email_error_1:
    "We weren't able to send your personal shopping link to {{email}}, so your registration wasn't saved.",
  sign_up_email_error_2:
    "Please try again in a few minutes. If it keeps happening, contact the event organizer.",
  sign_up_db_error_title: "Something went wrong",
  sign_up_user_exists_title: "You're already registered",
  sign_up_user_exists_resent:
    "We've re-sent your personal shopping link to this address. Please check your inbox and spam folder.",
  sign_up_user_exists_throttled:
    "Your personal shopping link was sent to this address in the last few minutes. Please check your inbox and spam folder.",
  sign_up_user_exists_resend_failed:
    "We couldn't re-send your shopping link right now. Please try again later or contact the event organizer."
};

const withDefault = (key) => ({ key, defaultValue: GENERAL_INVITE_DEFAULTS[key] });

// Heading and intro of the thank-you screen. When the invite email failed but
// the member is registered, tell them they are ready to shop.
export const thankYouHeadingKey = ({ inviteEmailFailed } = {}) =>
  inviteEmailFailed === true
    ? withDefault("register_ready_to_shop_1")
    : { key: "register_thank_you_1" };

export const thankYouIntroKey = ({ inviteEmailFailed } = {}) =>
  inviteEmailFailed === true
    ? withDefault("register_ready_to_shop_2")
    : { key: "register_thank_you_2a" };

// Line shown under the Start Shopping / Copy Link buttons on the thank-you
// screen. Returns { key, defaultValue? } for t(key, { defaultValue }).
export const thankYouEmailLineKey = ({ inviteEmailFailed } = {}) =>
  inviteEmailFailed === true
    ? withDefault("register_thank_you_2d")
    : { key: "register_thank_you_2c" };

const USER_EXISTS_FOLLOWUP_KEYS = {
  sent: "sign_up_user_exists_resent",
  throttled: "sign_up_user_exists_throttled",
  failed: "sign_up_user_exists_resend_failed"
};

// Second line of the "Participant Exists" modal. Old function responses carry
// no inviteResent and keep today's copy.
export const userExistsFollowupKey = (inviteResent) => {
  const known = Object.prototype.hasOwnProperty.call(
    USER_EXISTS_FOLLOWUP_KEYS,
    inviteResent
  );
  return known
    ? withDefault(USER_EXISTS_FOLLOWUP_KEYS[inviteResent])
    : { key: "sign_up_user_exists_2" };
};

export const userExistsTitleKey = () => withDefault("sign_up_user_exists_title");

// Title and body lines of the processingError modal. `reason` is only set when
// the function rolled back because the invite email failed; sign_up_email_error_1
// needs the submitted email interpolated by the caller.
export const processingErrorMessage = (reason) =>
  reason === "inviteEmailFailed"
    ? {
        title: withDefault("sign_up_email_error_title"),
        lines: [
          withDefault("sign_up_email_error_1"),
          withDefault("sign_up_email_error_2")
        ]
      }
    : {
        title: withDefault("sign_up_db_error_title"),
        lines: [
          { key: "sign_up_db_error_1" },
          { key: "sign_up_db_error_2" },
          { key: "sign_up_db_error_3" }
        ]
      };
